export default {
  seconds: { value: 'seconds', label: 'секунд' },
  minutes: { value: 'minutes', label: 'минут' },
  hours: { value: 'hours', label: 'часов' },
  days: { value: 'days', label: 'дней' }
};
